import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'bb-flag',
	templateUrl: './bb-flag.component.html',
	styleUrls: ['./bb-flag.component.scss']
})

export class BbFlagComponent implements OnInit {
	@Input() countryCode: string;

	constructor() { }

	ngOnInit() { }
}
